import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RolesMaster } from "../types/assetTypes";

interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  role: RolesMaster[],
  name: string,
  email: string,
  userId: number,
  projectIds: number[],
}

export const initialState: AuthState = {
  isAuthenticated: false,
  token: null,
  role:[],
  name: '',
  email: "",
  userId: 0,
  projectIds: []
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setAuthentication: (state, action: PayloadAction<AuthState>) => {
      state.isAuthenticated = action.payload.isAuthenticated;
      state.token = action.payload.token;
      state.name = action.payload.name;
      state.role = action.payload.role;
      state.email = action.payload.email;
      state.userId = action.payload.userId;
      state.projectIds = action.payload.projectIds;
    },
    logout: (state, action: PayloadAction<void>) => {
      state.isAuthenticated = false;
      state.token = null;
      state.role = [];
      state.name = "";
      state.email = "";
      state.userId = 0;
    },
  },
});

export const { logout, setAuthentication } = authSlice.actions;
export const authReducer = authSlice.reducer;
export default authSlice;